import { z } from "zod";
import { farmAdviceSolutionDtoSchema } from "./farm-advice-solution.schema";
import { richTextBlockDtoSchema } from "./rich-text-block.schema";
export const farmAdviceDrillDownItemDtoSchema = z.object({
    id: z.string(),
    solutionsTitle: z.string(),
    solutions: z.array(farmAdviceSolutionDtoSchema),
    problem: z.array(richTextBlockDtoSchema),
});
export const farmAdviceDrillDownDtoSchema = z.object({
    title: z.string(),
    items: z.array(farmAdviceDrillDownItemDtoSchema),
});
//# sourceMappingURL=farm-advice-drill-down.schema.js.map